// src/js/config/ui/toggleDeleteButtonVisibility.js

import { DOMElements } from '../dom.js';

/**
 * Visar eller döljer "Ta bort konfiguration"-knappen baserat på om ett val har gjorts.
 * @param {string} selectedValue - Värdet från select-listan.
 */
export function toggleDeleteButtonVisibility(selectedValue) {
    const { deleteConfigBtn } = DOMElements;

    if (!deleteConfigBtn) {
        console.warn("Delete-knappen (deleteConfigBtn) saknas.");
        return;
    }

    const hasValidSelection = selectedValue && selectedValue !== "default";
    deleteConfigBtn.style.display = hasValidSelection ? 'block' : 'none';
}